var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLogoSmart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 231.503,
    height: 93.752,
    viewBox: "0 0 231.503 93.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-icon-text-1",
    transform: "translate(-115 -415.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(338.698 342.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(-75.197 73.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0 28.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M415,217.052c5.055-.164,10.151-.288,15.205-.329l15.205-.123,15.205.082c5.055.041,10.15.164,15.205.329a3.8,3.8,0,0,1,0,7.6c-5.055.164-10.151.288-15.205.329l-15.205.082L430.2,224.9c-5.055-.041-10.151-.164-15.205-.329a3.761,3.761,0,0,1,0-7.52Z",
    transform: "translate(-403.925 -216.6)",
    fill: "#00a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M396.826,260.6c12.657-1.11,25.356-1.356,38.013-1.4,12.657.041,25.356.288,38.013,1.4a3.814,3.814,0,0,1,0,7.6c-12.657,1.069-25.356,1.356-38.013,1.4-12.657-.041-25.356-.288-38.013-1.4a3.774,3.774,0,0,1-3.452-4.151A3.816,3.816,0,0,1,396.826,260.6Z",
    transform: "translate(-393.356 -241.693)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M414.857,305.268c10.151-.822,20.26-1.027,30.41-1.069,10.151.041,20.26.206,30.411,1.069a4.145,4.145,0,0,1,0,8.26c-10.151.863-20.26,1.027-30.411,1.069-10.151-.041-20.26-.247-30.41-1.069a4.145,4.145,0,0,1,0-8.26Z",
    transform: "translate(-403.784 -268.2)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M433.122,349.963c7.6-.658,15.205-.822,22.808-.863,7.6,0,15.205.164,22.808.863a4.353,4.353,0,0,1,0,8.671c-7.6.7-15.205.863-22.808.863-7.6-.041-15.205-.205-22.808-.863a4.353,4.353,0,0,1,0-8.671Z",
    transform: "translate(-414.446 -294.649)",
    fill: "#fc3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(1.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M531.3,171.02a29.473,29.473,0,0,1,1.315-9,22.233,22.233,0,0,1,4.438-8.137,19.712,19.712,0,0,1,7.726-5.548,25.97,25.97,0,0,1,4.6-1.438c1.562-.329,3.164-.411,4.767-.616a1.906,1.906,0,0,1,.493,3.781h-.493c-1.4.041-2.836-.041-4.233.082a20.622,20.622,0,0,0-4.151.822,16.728,16.728,0,0,0-7.315,4.151,21.822,21.822,0,0,0-4.932,7.151A30.817,30.817,0,0,0,531.3,171.02Z",
    transform: "translate(-475.898 -146.267)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M421.484,171.1a27.525,27.525,0,0,0-2.219-8.671,20.819,20.819,0,0,0-4.931-7.151,16.729,16.729,0,0,0-7.315-4.151,23.192,23.192,0,0,0-4.151-.822c-1.4-.123-2.836-.041-4.233-.082h-.288a1.912,1.912,0,0,1,.123-3.822h.164c1.6.205,3.205.288,4.767.616a25.974,25.974,0,0,1,4.6,1.438A19.31,19.31,0,0,1,415.73,154a22.854,22.854,0,0,1,4.438,8.137A27.526,27.526,0,0,1,421.484,171.1Z",
    transform: "translate(-396.496 -146.343)",
    fill: "#fc3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "logo-text-1",
    transform: "translate(10 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(105 452.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M251.152,474.34a15.316,15.316,0,0,0-6.471-2.311,15.619,15.619,0,0,0,6.058-2.238,10.879,10.879,0,0,0,3.844-4.233,12.924,12.924,0,0,0,1.314-5.936,16.223,16.223,0,0,0-2.044-8.369,13.208,13.208,0,0,0-5.985-5.328,22.454,22.454,0,0,0-9.488-1.825H215v57.293h24.012a22.569,22.569,0,0,0,9.512-1.825,13.315,13.315,0,0,0,6.033-5.328,16.266,16.266,0,0,0,2.068-8.442v-.122a15.181,15.181,0,0,0-1.387-6.666A11.48,11.48,0,0,0,251.152,474.34Zm-13.137-19.852a7.838,7.838,0,0,1,5.182,1.533,5.314,5.314,0,0,1,1.825,4.306A6.179,6.179,0,0,1,243.2,465.1a7.386,7.386,0,0,1-5.182,1.7H225.8V454.513h12.213Zm7.761,29.68a6.348,6.348,0,0,1-2.019,5.012,8.412,8.412,0,0,1-5.741,1.8H225.8V477.186h12.213a9.953,9.953,0,0,1,4.184.8,5.8,5.8,0,0,1,2.652,2.335,7.122,7.122,0,0,1,.9,3.7v.146Z",
    transform: "translate(-215 -444.1)",
    fill: "#00a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M432.992,444.1H429.1v57.269h38.366V490.981H439.877V478.135h23.258V467.723H439.877V454.488h27.588V444.1H432.992Z",
    transform: "translate(-377.013 -444.1)",
    fill: "#00a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M665.666,454.488V444.1H627.3v57.269h38.366V490.981H638.1V478.135h23.233V467.723H638.1V454.488Z",
    transform: "translate(-526.995 -444.1)",
    fill: "#00a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(105 415.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M222.1,752.392a15.9,15.9,0,0,1-3.8-1.314,16.257,16.257,0,0,1-3.309-2.19l1.9-2.506a13.629,13.629,0,0,0,4.355,2.628,14.852,14.852,0,0,0,5.182.876,10.416,10.416,0,0,0,6.277-1.63,5.288,5.288,0,0,0,2.214-4.549v-.024a4.194,4.194,0,0,0-.973-2.919,5.84,5.84,0,0,0-2.506-1.63,25.527,25.527,0,0,0-3.941-1,.309.309,0,0,0-.146-.024c-.049,0-.1-.024-.17-.024l-.633-.122a40.917,40.917,0,0,1-5.3-1.314,7.8,7.8,0,0,1-3.406-2.336,6.9,6.9,0,0,1-1.411-4.574v-.024a9.241,9.241,0,0,1,1.314-5.036,8.282,8.282,0,0,1,3.82-3.187,16.5,16.5,0,0,1,9.366-.73,16.363,16.363,0,0,1,3.236,1.095,18.416,18.416,0,0,1,3.163,1.849l-1.849,2.482a17.519,17.519,0,0,0-3.99-2.165,11.416,11.416,0,0,0-3.868-.706,9.572,9.572,0,0,0-5.985,1.63,5.5,5.5,0,0,0-2.117,4.622v.024a3.854,3.854,0,0,0,1.07,2.846,6.423,6.423,0,0,0,2.627,1.533,40.246,40.246,0,0,0,4.306,1.046c.049.024.122.024.195.049s.122.024.195.049c.1.024.17.024.243.049a.865.865,0,0,0,.243.049,29.393,29.393,0,0,1,4.939,1.411,7.821,7.821,0,0,1,3.284,2.457,7.15,7.15,0,0,1,1.314,4.525v.049a8.945,8.945,0,0,1-1.362,4.987,8.515,8.515,0,0,1-3.965,3.163,16.063,16.063,0,0,1-6.252,1.095A26.8,26.8,0,0,1,222.1,752.392Z",
    transform: "translate(-215 -720.4)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M357.225,721.5h3.284v31.821h-3.138V726l.316,1.411L348.2,748.918h-2.214L336.5,727.85l.316-1.849v27.345H333.7V721.5h3.284L347.1,744.49Z",
    transform: "translate(-304.822 -721.232)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M473.253,721.5h3.771l11.629,31.821h-3.479l-10.048-28.513-10.048,28.513H461.6Zm-6.277,21.166h16.592v2.944H466.977Z",
    transform: "translate(-401.606 -721.232)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M592.4,721.4h3.114v31.846H592.4Zm1.922,15.473h10.753a6.134,6.134,0,0,0,3.09-.779,5.14,5.14,0,0,0,2.068-2.19,7.425,7.425,0,0,0,.754-3.284,7.1,7.1,0,0,0-.73-3.284,5.141,5.141,0,0,0-2.068-2.19,6.162,6.162,0,0,0-3.114-.778H594.322v-2.944H604.9a9.765,9.765,0,0,1,4.793,1.143,7.77,7.77,0,0,1,3.211,3.236,10.718,10.718,0,0,1,0,9.634,7.912,7.912,0,0,1-3.211,3.236,9.9,9.9,0,0,1-4.793,1.143H594.322Zm10.1,1.946,2.9-1,8.077,15.448h-3.722Z",
    transform: "translate(-500.585 -721.157)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M693.5,721.5h22.26v2.944H693.5Zm9.585,1.289H706.2v30.532h-3.114Z",
    transform: "translate(-577.089 -721.232)",
    fill: "#fc3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmart);
export default __webpack_public_path__ + "static/media/logo-smart.5781531cb7858d37b6410869834b3aed.svg";
export { ForwardRef as ReactComponent };